import { EmspUserInvoiceBaseModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/emsp-user-invoice-base.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface EmspBoInvoiceListStatusHeaderProps
  extends HeaderContext<
    EmspUserInvoiceBaseModel,
    EmspUserInvoiceBaseModel['status']
  > {}

export const EmspBoInvoiceListStatusHeader =
  (): // props: EmspBoInvoiceListStatusHeaderProps,
  ReactNode => {
    // CONTEXT ///////////////////////////////////////////////////////////////////

    const { t } = useTranslation();

    // RENDER ////////////////////////////////////////////////////////////////////

    return t('delmonicos-shared-sdk.outputs-invoice.status');
  };
